<!--
 * @Author: your name
 * @Date: 2020-12-03 18:33:23
 * @LastEditTime: 2020-12-04 15:24:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\salesTerminal\appointmentQueue\list.vue
-->
<template>
    <div class="appointmentQueueList">
        <van-nav-bar
            title="预约排队"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        >
            <template #right>
                <!-- 下拉选择 -->
                <van-dropdown-menu style="color:#fff;right:0">
                    <van-dropdown-item
                        style="right:0"
                        v-model="currentStationId"
                        :options="stationList"
                        @change="changeStation"
                    ></van-dropdown-item>
                </van-dropdown-menu>
            </template>
        </van-nav-bar>
        <div class="container">
            <div class="search-con">
                <!-- <input
                    class="search-input"
                    v-model="searchVal"
                    placeholder="请输入车牌号/供应单号查询"
                    @change="onSearch"
                > -->
                <van-search
                    v-model="searchVal"
                    placeholder="请输入车牌号/供应单号查询"
                    clearable
                    @input="onSearch"
                ></van-search>
            </div>
            <div class="change-btn" @click="toMap">
                <div>
                    <span class="iconfont iconditu"></span>
                </div>
                <p>地图</p>
            </div>
            <ul class="list-con">
                <li v-for="item in list" :key="item.supply_no">
                    <div class="supply-no">
                        <span class="iconfont iconorder"></span>
                        <span>供应单号:{{ item.supply_no }}</span>
                    </div>
                    <div class="sort-num">
                        <div>
                            <span class="spec-code">
                                <span v-if="item.type_name">{{ item.type_name }}</span>
                                <span v-if="item.goods_name">-{{ item.goods_name }}</span>
                                <span v-if="item.spec_name">-{{ item.spec_name }}</span>
                            </span>
                        </div>
                        <div class="sort-con">
                            当前排在第<span class="num">{{ item.sort_num }}</span>位
                        </div>
                    </div>
                    <div class="time-con">
                        <div>
                            <div class="time">
                                {{ item.begin_time }}
                            </div>
                            <div class="lable">
                                出厂时间
                            </div>
                        </div>
                        <div class="arrow-con">
                            <div class="distanse">
                                {{ item.to_distance }}km
                            </div>
                            <div class="distanse">
                                <span class="tag">{{ item.plate_number }}</span>
                            </div>
                        </div>
                        <div>
                            <div class="time">
                                {{ item.estimated_time }}
                            </div>
                            <div class="lable">
                                出厂时间
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            searchVal: '',
            list: [],
            // 场站
            stationList: [],
            // 当前场站id
            currentStationId: '',
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
        this.getStationUser();
    },
    methods: {
        // 返回
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 模糊搜索
        onSearch() {
            this.getCarsLocation();
        },
        // 切换场站
        changeStation() {
            this.getCarsLocation();
        },
        // 跳转到地图界面
        toMap() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 拉取用户关联场站
        getStationUser() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        value: id,
                        text: stationNames[index],
                    };
                });
                this.stationList = stationList;
                this.currentStationId = stationList[0].value;
                this.getCarsLocation();
            }
        },
        // 拉取场站下所有车辆位置
        async getCarsLocation() {
            const res = await this.$axios.$get('/interfaceApi/wechat/carlocation/get_cars_location?station_id='
            + this.currentStationId + '&keywords=' + this.searchVal);
            if (res) {
                // let arr = [
                //     {
                //         supply_no: '【SP】GYD202011-006',
                //         plate_number: '33333333',
                //         longitude: 123.456,
                //         latitude: 39.85856,
                //         speed: 31.318429771532895,
                //         direction: 270.0,
                //         to_distance: 77846.134397532936,
                //         sort_num: 1,
                //         begin_time: '2020-12-01 09:36:18',
                //         estimated_time: '2020-12-03 18:02:14',
                //         type_name: '石',
                //         goods_name: '卵石',
                //         spec_name: '16-31.5',
                //     },
                // ];
                let arr = [];
                arr = res.map(item => {
                    if (item.to_distance) {
                        item.to_distance = (item.to_distance / 1000).toFixed(2);
                    }
                    if (item.begin_time) {
                        item.begin_time = item.begin_time.substr(11, item.begin_time.length);
                    }
                    if (item.estimated_time) {
                        item.estimated_time = item.estimated_time.substr(11, item.estimated_time.length);
                    }
                    return item;
                });
                this.list = arr;
            }
        },
    },
};
</script>
<style lang="stylus">
.appointmentQueueList
    height 100%
    .van-dropdown-menu__bar
        background-color transparent
        height 40rpx
        .van-dropdown-menu__title
            color #fff
    .container
        height calc(100% - 40rpx)
        .search-con
            height 44rpx
            background #EAEAEA
            .van-search
                margin-bottom 8rpx
        .change-btn
            padding 5rpx 10rpx 10rpx 10rpx
            background #0189FC
            box-shadow 2rpx 2rpx 4rpx 0 rgba(0, 0, 0, 0.35)
            border-radius 4rpx
            position absolute
            bottom 15rpx
            right 20rpx
            z-index 10
            text-align center
            color #fff
            .iconfont
                font-size 20rpx
            p
                font-size 12rpx
        .list-con
            height calc(100% - 44rpx)
            overflow-y auto
            overflow-x hidden
            padding 10rpx 15rpx
            background #F0F0F0
            li
                background #FFFFFF
                box-shadow 0px 0px 4px 0px rgba(0, 0, 0, 0.2)
                border-radius: 4px
                margin-bottom 10rpx
                .supply-no
                    height 36rpx
                    line-height 36rpx
                    padding-left 15rpx
                    color #0189FC
                    .iconfont
                        margin-right 5rpx
                .sort-num
                    height 35rpx
                    background-color #F0F0F0
                    padding 0 15rpx
                    display flex
                    justify-content space-between
                    font-size 14rpx
                    align-items center
                    .spec-code
                        color #333333
                    .sort-con
                        font-size 12rpx
                        color #666666
                        .num
                            font-size 16rpx
                            color #FF6600
                .time-con
                    display flex
                    // align-items center
                    height 69rpx
                    padding 15rpx
                    .arrow-con
                        background url(./../../../assets/images/productionManagement/arrow_window.png) no-repeat bottom center
                        width 148rpx
                        height 22rpx
                        margin 0 20rpx
                        .distanse
                            text-align center
                            color #01A675
                    .time
                        font-size 14rpx
                        color #333333
                    .lable
                        font-size 12rpx
                        color #979EA7
                    .tag
                        padding 2rpx 5rpm
                        font-size 12rpx
                        color #FF8534
                        margin-right 10rpx
                        margin-top 10rpx
</style>
